import { Formik } from 'formik';
import { useEffect, useRef, useState } from 'react';
import * as Yup from 'yup';
import Input from '../../../../components/form-control/Input';
import Button from '../../../../components/form-control/Button';
import { ShieldExclamationIcon } from '@heroicons/react/24/solid';
import { Policy } from '../../../../models/policy/Policy';
import { getFormattedPhoneNumber, showToast } from '../../../../utils/miscFunctions';
import { IVerifyCustomerDTO } from '../../customers/ViewCustomer';
import { sendCustomerOTP, sendOTPToPhone, verifyNonCustomerPhoneOTP, verifyPhoneOTP } from '../../../../api/requests';
import { HomePolicy } from '../../../../models/homePolicy/HomePolicy';
import Loader from '../../../../components/Loader';

export interface ICustomerPhoneVerificationModal {
  policy: Policy | HomePolicy | undefined;
  close: () => void;
  onProceed: () => void;
  phoneNumber?: string;
  isCustomer?: boolean;
  id?: number;
}

const PhoneVerificationModal = ({ policy, close, onProceed, phoneNumber, isCustomer = true, id }: ICustomerPhoneVerificationModal) => {
  const [phone, setPhone] = useState<string>(phoneNumber ? getFormattedPhoneNumber(phoneNumber) : isCustomer ? getFormattedPhoneNumber(policy?.applicant?.phoneNumber ?? "") : "");
  const [sending, setSending] = useState<boolean>(false);
  const [otpSent, setOtpSent] = useState<boolean>(false);
  const otpSentRef = useRef<boolean>(false);

  useEffect(() => {
    if (phone && !otpSentRef.current) {
      otpSentRef.current = true;
      resendOTP();
    }
  }, [phone])

  const resendOTP = () => {
    if (phone) {
      setSending(true);

      if (isCustomer) {
       id && sendCustomerOTP(id, phone)
          .then((response: any) => {
            if (response) {
              showToast.success(response.message);
              setOtpSent(true);
            }
          })
          .catch((error: any) => {
            showToast.error(error.description);
            setOtpSent(false);
          }).finally(() => setSending(false));
      } else {
        sendOTPToPhone(phone)
          .then((response: any) => {
            if (response) {
              showToast.success(response.message);
              setOtpSent(true);
            }
          })
          .catch((error: any) => {
            showToast.error(error.description);
            setOtpSent(false);
          }).finally(() => setSending(false));
      }
    }
  };

  const verifyOTP = (values: any) => {
    if (phone) {
      const VERIFICATION_CODE_CONSTANT = 'B-';
      const payload: IVerifyCustomerDTO = {
        verificationCode: VERIFICATION_CODE_CONSTANT + values.code,
        customerId: id,
        accountProviders: 'PHONE',
        identifier: phone
      };

      if (isCustomer) {
        id && verifyPhoneOTP(id, payload)
          .then((response: any) => {
            if (response) showToast.success(response);
            onProceed();
          })
          .catch((error: any) => {
            showToast.error(error.description);
          });
      } else {
        verifyNonCustomerPhoneOTP(payload)
          .then((response: any) => {
            if (response) showToast.success(response);
            onProceed();
          })
          .catch((error: any) => {
            showToast.error(error.description);
          });
      }

    }
  };

  return (
    <div className="bg-white rounded-xl">
      {/* Modal Header */}

      {/* Modal Body */}
      {sending ? (
        <div className='my-12'>
          <Loader message='Sending otp...' />
        </div>

      ) : (
        <>
          <div className="p-[1rem] w-full">
            {otpSent ? (
              <>
                <div className=" mt-[26px]">
                  <span className="text-center">
                    Enter the verification code provided by the customer
                  </span>
                </div >
                <Formik
                  initialValues={{
                    code: ''
                  }}
                  validateOnChange={false}
                  validateOnBlur={false}
                  validationSchema={Yup.object({
                    code: Yup.string()
                      .trim()
                      .min(6, 'Invalid verification code')
                      .max(6, 'Invalid verification code')
                      .required('Verification code is required')
                  })}
                  onSubmit={(values) => {
                    // submitHandler(values);
                  }}>
                  {({ values, errors, handleSubmit, handleChange, setFieldValue, handleBlur, touched }) => (
                    <form className="space-y-4 py-[1rem]" onSubmit={handleSubmit}>
                      <div className="flex flex-col gap-5">
                        <div className="flex">
                          <div className="">
                            <Input
                              type="text"
                              name="code"
                              label="Verification code"
                              placeholder=""
                              className="rounded-r-[0px] h-[40px] placeholder-[#848484] focus:ring-primary-border "
                              value={values.code}
                              onChange={handleChange}
                              onBlur={handleBlur}
                              prepend={'B-'}
                            />
                          </div>

                          <div className="flex ">
                            <Button
                              label="Verify OTP"
                              title=" "
                              bgColor="primary"
                              fullWidth
                              onClick={() => verifyOTP(values)}
                            />
                          </div>
                        </div>
                      </div>
                    </form>
                  )}
                </Formik>
              </>
            ) : (
              <div className='flex items-center my-2'>
                <ShieldExclamationIcon className='w-6 mr-2 text-danger-pressed' /> <span>Failed to send otp.</span>
              </div>
            )}

            <div className="">
              <span
                className="text-blue-700 cursor-pointer hover:underline text-sm"
                onClick={() => resendOTP()}>
                Resend verification code
              </span>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PhoneVerificationModal;
